import type { SliceStateCreator } from "../types";

export interface UISliceState {
  ui: {
    liveChatRoomUuid: null | string;
    dmSelectedTabIndex: number;
    setLiveChatRoomUuid: (uuid: string | null) => void;
    setDmSelectedTabIndex: (index: number) => void;
  };
}

export const createUISlice: SliceStateCreator<UISliceState> = set => ({
  ui: {
    liveChatRoomUuid: null,
    setLiveChatRoomUuid: (uuid: string | null) =>
      set(state => {
        state.ui.liveChatRoomUuid = uuid;
      }),
    dmSelectedTabIndex: 0,
    setDmSelectedTabIndex: (index: number) =>
      set(state => {
        state.ui.dmSelectedTabIndex = index;
      }),
  },
});
